function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "user",
  transform: "translate(-6.75 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11490",
  "data-name": "Path 11490",
  d: "M25.949,6.771a11.3,11.3,0,1,1-11.3,11.3,11.3,11.3,0,0,1,11.3-11.3m0-4.521A15.824,15.824,0,1,0,41.774,18.074,15.824,15.824,0,0,0,25.949,2.25Z",
  transform: "translate(3.407 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11491",
  "data-name": "Path 11491",
  d: "M51.963,47.378H47.441v-11.3a11.3,11.3,0,0,0-11.3-11.3H22.574a11.3,11.3,0,0,0-11.3,11.3v11.3H6.75v-11.3A15.824,15.824,0,0,1,22.574,20.25H36.138A15.824,15.824,0,0,1,51.963,36.074Z",
  transform: "translate(0 18.17)",
  fill: "#ac1ede"
}));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.213,
    height: 63.298,
    viewBox: "0 0 45.213 63.298",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.80ea6a36.svg";
export { ForwardRef as ReactComponent };